import React, { useContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { CartContext } from '../../contexts/CartContext';

export const ContinueToPayment = () => {
    const { setSubmitCreateAccount, createAccountErrorMessage } = useContext(CartContext);
    const { t } = useTranslation();
    const [isSubmitting, setIsSubmitting] = useState(false);

    // Reset isSubmitting when error occurs so user can retry
    useEffect(() => {
        if (createAccountErrorMessage) {
            setIsSubmitting(false);
        }
    }, [createAccountErrorMessage]);

    const continueToPayment = () => {
        if (isSubmitting) return;
        setIsSubmitting(true);
        setSubmitCreateAccount(true);
    };

    return (
        <>
            <div className="placeorder__wrap button--sticky gotoPlaceOrder">
                <button
                    id="submit"
                    className="button placeorder__button--black"
                    onClick={continueToPayment}
                    data-link-type="cta button"
                    data-link-title="continue to payment"
                    data-component-type="express checkout"
                    disabled={!!createAccountErrorMessage || isSubmitting}
                >
                    <span>{t('Continue To Payment')}</span>
                </button>
            </div>
        </>
    );
};
